var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contentContainer item"},[_c('v-layout',[_c('v-flex',{attrs:{"sm12":"","md6":""}},[(_vm.teacher)?_c('Hours',{attrs:{"type":'ContractHour',"user":_vm.teacher.id,"role":_vm.teacher.filters.role}}):_vm._e()],1),_c('v-flex',{attrs:{"sm12":"","md6":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }